import { Ref, forwardRef } from 'react'

import Chip, { ChipProps } from '../../ui/Chip'
import AccessibleComponent from '../AccessibleComponent'

const AccessibleChip = forwardRef((props: ChipProps, ref: Ref<unknown>) => {
  return (
    <AccessibleComponent component={Chip} componentProps={props} ref={ref} />
  )
})

export default AccessibleChip
